import { ConversationTeamEffects } from './conversation-team.effects'
import { TeamEffects } from './team.effects'
import { UsersEffects } from './users.effects'
import { MembersEffects } from './members.effects'

export * from './team.effects'
export * from './members.effects'
export * from './users.effects'
export * from './conversation-team.effects'

export const effects: any[] = [TeamEffects, UsersEffects, MembersEffects, ConversationTeamEffects]




// WEBPACK FOOTER //
// ./src/app/shared/team/store/effects/index.ts